import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import './classes/ProductScan.css';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet';

const ProductScan = () => {
    const products = [
        { id: 1, name: "turmeric powder", price: 5, barcode: "10001" },
        { id: 2, name: "amla juice", price: 6, barcode: "10002" },
        { id: 3, name: "mixed fruits", price: 7, barcode: "10003" },
        { id: 4, name: "bath soap", price: 8, barcode: "10004" },
        { id: 5, name: "toothpaste", price: 4, barcode: "10005" },
        { id: 6, name: "shampoo", price: 9, barcode: "10006" },
        { id: 7, name: "rice 1kg", price: 12, barcode: "10007" },
        { id: 8, name: "wheat flour 1kg", price: 10, barcode: "10008" },
        { id: 9, name: "sugar 1kg", price: 6, barcode: "10009" },
        { id: 10, name: "salt packet", price: 2, barcode: "10010" },
        { id: 11, name: "cooking oil 1L", price: 15, barcode: "10011" },
        { id: 12, name: "milk 1L", price: 3, barcode: "10012" },
        { id: 13, name: "butter", price: 5, barcode: "10013" },
        { id: 14, name: "bread loaf", price: 3, barcode: "10014" },
        { id: 15, name: "biscuits", price: 2, barcode: "10015" },
        { id: 16, name: "tea powder", price: 7, barcode: "10016" },
        { id: 17, name: "coffee powder", price: 8, barcode: "10017" },
        { id: 18, name: "detergent powder", price: 11, barcode: "10018" },
        { id: 19, name: "handwash", price: 4, barcode: "10019" },
        { id: 20, name: "face wash", price: 6, barcode: "10020" }
    ];

    const [searchValue, setSearchValue] = useState("");
    const [options, setOptions] = useState([]);
    const [cart, setCart] = useState([]);
    const grandTotal = cart.reduce((sum, item) => sum + item.total, 0);

    const [editItem, setEditItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        const handler = setTimeout(() => {
        if (searchValue.trim() === "") {
            setOptions([]);
            return;
        }
        setOptions(products.filter(p => p.name.includes(searchValue.toLowerCase())));
        }, 300);

        return () => clearTimeout(handler);
    }, [searchValue]);

    const addProductToCart = (product) => {
        setCart((prev) => {
        const existing = prev.find((p) => p.id === product.id);

        if (existing) {
            return prev.map((p) =>
            p.id === product.id
                ? { ...p, qty: p.qty + 1, total: (p.qty + 1) * p.price }
                : p
            );
        }

        return [
            ...prev,
            { ...product, qty: 1, total: product.price },
        ];
        });

        setSearchValue("");
        setOptions([]);

        setTimeout(() => {
        inputRef.current?.focus();
        }, 0);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            const input = searchValue.trim();

            if (!input) return;

            //  check barcode
            const barcodeMatch = products.find(
            (p) => p.barcode === input
            );

            if (barcodeMatch) {
            addProductToCart(barcodeMatch);
            return;
            }

            //  If not barcode, check product name
            const nameMatch = products.find(
            (p) => p.name.toLowerCase() === input.toLowerCase()
            );

            if (nameMatch) {
            addProductToCart(nameMatch);
            }
        }
    };


    const increaseQty = (id) => {
        setCart((prev) =>
            prev.map((item) =>
            item.id === id
                ? {
                    ...item,
                    qty: item.qty + 1,
                    total: (item.qty + 1) * item.price,
                }
                : item
            )
        );
    };

    const decreaseQty = (id) => {
        setCart((prev) =>
            prev
            .map((item) =>
                item.id === id
                ? {
                    ...item,
                    qty: item.qty - 1,
                    total: (item.qty - 1) * item.price,
                    }
                : item
            )
            .filter((item) => item.qty > 0) // remove if qty becomes 0
        );
    };

    const openEditModal = (item) => {
        setEditItem({ ...item });
        setIsModalOpen(true);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditItem((prev) => ({
            ...prev,
            [name]: name === "price" || name === "qty"
            ? Number(value)
            : value,
        }));
    };

    const saveEdit = () => {
        setCart((prev) =>
            prev.map((item) =>
            item.id === editItem.id
                ? {
                    ...editItem,
                    total: editItem.qty * editItem.price,
                }
                : item
            )
        );
        setIsModalOpen(false);
    };

    const deleteProduct = (id) => {
        setCart((prev) => prev.filter((item) => item.id !== id));
    };

    

    return (
        <div className="pos-main">
            <Helmet>
                <title>Billing</title>
            </Helmet>
            <div className="main">
                {/* <div className="left-container">
                    <div className="barcode-search-container">
                    <h3>Barcode Search</h3>
                    <div className="barcode-search">
                    <FontAwesomeIcon className="barcode-icon" icon={solidIcons.faBarcode}  />&nbsp;
                    <input
                    // className="barcode-search"
                    type="text"
                    ref={barcodeRef}
                    onKeyDown={handleBarcodeScan}
                    placeholder="Scan barcode..."
                    // style={{ position: "absolute", opacity: 0 }}
                    />
                    </div>
                    </div>
                </div> */}
                <div className="product-search-container"> 
                    <Autocomplete
                        id="product_search"
                        disablePortal
                        options={options}
                        getOptionLabel={(option) => option.name}
                        //freeSolo
                        inputValue={searchValue}
                        onInputChange={(event, value) => setSearchValue(value)}
                        onKeyDown={handleKeyDown}         
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            inputRef={inputRef}
                            placeholder="Search..."
                            />
                        )}
                    />
                    <div className="total-amount-container">
                    <h3>Total Amount:</h3>&nbsp;
                    <h2>₹ {grandTotal}</h2>
                    </div>
                    <table className="cart-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th style={{textAlign: "center"}}>Qty</th>
                                <th style={{textAlign: "center"}}>Price</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cart.map((item) => (
                            <tr key={item.id} className="cart-row">
                                <td className="product-cell">
                                <div className="product-name">{item.name}</div>
                                <div className="product-id">{item.id}</div>
                                </td>

                                <td className="qty-cell">{item.qty}</td>
                                <td className="total-cell">₹{item.total}</td>
                                <td className="icon-cell">
                                    <FontAwesomeIcon className="plus" icon={solidIcons.faSquarePlus} onClick={() => increaseQty(item.id)} />&nbsp;
                                    <FontAwesomeIcon className="minus" icon={solidIcons.faSquareMinus} onClick={() => decreaseQty(item.id)} />&nbsp;
                                    <FontAwesomeIcon className="edit" icon={solidIcons.faEdit} onClick={() => openEditModal(item)} />&nbsp;
                                    <FontAwesomeIcon className="delete" icon={solidIcons.faTrash} onClick={() => deleteProduct(item.id)} />
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="grand-total-first-container">
                        <div className="grand-total-container">
                            <h3>Total Amount:</h3>
                            <h2>₹ {grandTotal}</h2>
                        </div>
                    </div>

                    {isModalOpen && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                <h3>Edit Product</h3>

                                <label>Product Name</label>
                                <input
                                    name="name"
                                    value={editItem.name}
                                    onChange={handleEditChange}
                                />

                                <label>Quantity</label>
                                <input
                                    type="number"
                                    name="qty"
                                    value={editItem.qty}
                                    onChange={handleEditChange}
                                />

                                <label>Price</label>
                                <input
                                    type="number"
                                    name="price"
                                    value={editItem.price}
                                    onChange={handleEditChange}
                                />

                                <div className="modal-buttons">
                                    <button onClick={saveEdit}>Save</button>
                                    <button onClick={() => setIsModalOpen(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
                {/* <div className="right">

                </div> */}
            </div>
        </div>
    );
};

export default ProductScan;
